"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GTMEventsTracker = void 0;
const lib_1 = require("../lib");
const GTMEventsTracker = () => {
    return {
        async track(event) {
            var _a;
            if (!window.dataLayer)
                throw lib_1.AnalyticsEventsTrackerError.NOT_INITIALIZED('GTMEventsTracker');
            const pushObject = Object.assign(Object.assign({}, ((_a = event.info) !== null && _a !== void 0 ? _a : {})), { event: event.name });
            window.dataLayer.push(pushObject);
        },
    };
};
exports.GTMEventsTracker = GTMEventsTracker;
